export default __webpack_public_path__ + "static/media/product-6.0c81efa9.png";